export default class dataParse {
   static data={
     settingData: true,
     pageData: false,
     linkData: false,
     moduleData: false,
   }

   static dataLoaded() {
     return !Object.keys(this.data).some((k) => !this.data[k]);
   }
}
